module.exports = __webpack_public_path__ + "media/images/icono-buscar-outline-2844403c.svg";